import { ViewType } from "../assets/constants";
import { matchPath, useLocation } from "react-router-dom";
import ROUTES from "../assets/routes";


const useSelectView = (): ViewType | null => {

    const {pathname} = useLocation();

    if (matchPath(ROUTES.chart, pathname)) return ViewType.CHART
    if (matchPath(ROUTES.optionChain, pathname)) return ViewType.OPTION_CHAIN
    if (matchPath(ROUTES.openInterestChange, pathname)) return ViewType.OPEN_INTEREST_CHANGE
    if (matchPath(ROUTES.openInterest, pathname)) return ViewType.OPEN_INTEREST
    if (matchPath(ROUTES.multiStrikeChart, pathname)) return ViewType.MULTI_STRIKES_CHART
    if(matchPath(ROUTES.strategyBuilder, pathname)) return ViewType.STRATEGY_BUILDER
    if(matchPath(ROUTES.simulator, pathname)) return ViewType.SIMULATOR
    if(matchPath(ROUTES.reports, pathname)) return ViewType.REPORTS
    if(matchPath(ROUTES.symbol, pathname)) return ViewType.SYMBOL
    if(matchPath(ROUTES.spread, pathname)) return ViewType.SPREAD
    return null;
}

export default useSelectView;